<hmf-selector
	class="toggle-select"
	[ngClass]="{ 'toggle-select-hover-mobile': !selected && isMobile }"
	[ariaLabel]="ariaLabel"
	[circleVariant]="circleVariant"
	[contained]="contained"
	[selector]="selector"
	[selected]="selected"
	(click)="toggleSelect()">
	<div
		ngProjectAs="rectangularSelectorBody"
		class="hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-px-xxs hmf-py-xs">
		<span class="content" [ngClass]="{ 'hmf-body-bold-m content-selected': selected, 'hmf-body-m': !selected }">{{content}}</span>
	</div>
</hmf-selector>
